"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { MessageSquareWarning } from "lucide-react"
import { ReportIssueModal } from "@/components/dashboard/shared/report-issue-modal"

export function ReportIssueButton() {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <Button
                variant="outline"
                size="sm"
                className="fixed bottom-4 right-4 gap-2 shadow-lg bg-background/80 backdrop-blur-sm border-border hover:bg-muted z-50 rounded-full"
                onClick={() => setIsOpen(true)}
            >
                <MessageSquareWarning className="h-4 w-4 text-muted-foreground" />
                <span className="text-xs font-medium text-muted-foreground">Report Issue</span>
            </Button>

            <ReportIssueModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
            />
        </>
    )
}
